import { Code, FileSpreadsheet } from "@/components/icons"
import { CodeBlock } from "@/features/chat/components/code-block"

const SAMPLE_CODE = `import pandas as pd
import matplotlib.pyplot as plt

df = pd.read_excel("sales_data.xlsx")
monthly = df.groupby("month")["revenue"].sum()
plt.bar(monthly.index, monthly.values)
plt.title("Monthly Revenue")`

const SAMPLE_ACTIVITIES = [
  {
    id: "1",
    icon: FileSpreadsheet,
    message: "**Analyzing uploaded file** sales_data.xlsx",
  },
  {
    id: "2",
    icon: Code,
    message: "**Executing code** to process data",
    code: SAMPLE_CODE,
  },
]

export function DemoCodeActivityMessages() {
  return (
    <div className="w-full space-y-3 sm:max-w-md">
      {SAMPLE_ACTIVITIES.map((activity) => (
        <article
          key={activity.id}
          className="bg-muted/10 relative flex flex-col gap-2 rounded-xl p-4 backdrop-blur-sm"
        >
          <header className="flex items-start gap-3">
            <div className="bg-muted/10 ring-primary/10 flex size-8 shrink-0 items-center justify-center rounded-lg ring-1">
              <activity.icon className="text-primary/40 size-4 shrink-0" strokeWidth={1.5} />
            </div>
            <div className="mt-1 min-w-0 flex-1">
              <p
                className="text-foreground/90 text-sm"
                dangerouslySetInnerHTML={{
                  __html: activity.message.replace(
                    /\*\*(.*?)\*\*/g,
                    '<strong class="font-semibold">$1</strong>'
                  ),
                }}
              />
            </div>
          </header>
          {"code" in activity && activity.code && (
            <CodeBlock className="language-python">{activity.code}</CodeBlock>
          )}
        </article>
      ))}
    </div>
  )
}
